/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PdpmEstimatorFieldReferenceMetaValue
 */
export interface PdpmEstimatorFieldReferenceMetaValue {
}

/**
 * Check if a given object implements the PdpmEstimatorFieldReferenceMetaValue interface.
 */
export function instanceOfPdpmEstimatorFieldReferenceMetaValue(value: object): value is PdpmEstimatorFieldReferenceMetaValue {
    return true;
}

export function PdpmEstimatorFieldReferenceMetaValueFromJSON(json: any): PdpmEstimatorFieldReferenceMetaValue {
    return PdpmEstimatorFieldReferenceMetaValueFromJSONTyped(json, false);
}

export function PdpmEstimatorFieldReferenceMetaValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdpmEstimatorFieldReferenceMetaValue {
    return json;
}

export function PdpmEstimatorFieldReferenceMetaValueToJSON(json: any): PdpmEstimatorFieldReferenceMetaValue {
    return PdpmEstimatorFieldReferenceMetaValueToJSONTyped(json, false);
}

export function PdpmEstimatorFieldReferenceMetaValueToJSONTyped(value?: PdpmEstimatorFieldReferenceMetaValue | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

